import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule, APP_CONFIG } from './app/app.module';
import { environment } from './environments/environment';

fetch('assets/data/appconfig.json')
  .then(response => response.json())
  .then(appConfig => {
    if (environment.production) {
      enableProdMode();
    }

    platformBrowserDynamic([{ provide: APP_CONFIG, useValue: appConfig }])
      .bootstrapModule(AppModule)
      .catch(err => console.error(err));
  });
